module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subscription-level"
  }, [(_vm.active === true) ? _c('img', {
    staticClass: "subscription-icon",
    attrs: {
      "src": "/static/img/bookmark.svg"
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-722bf7cf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/SubscriptionLevel/SubscriptionLevel.vue
// module id = 554
// module chunks = 1